import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';
import { articleImageUrls } from '@/mocks/imageUrls';

const faqData = [
  {
    question: '什么是日本成人视频合规观看渠道？',
    answer: '合规观看渠道指经过日本相关法律审批的正版内容分发平台，如FANZA、DMM等。这些平台的内容已通过第三方审查机构的审核，表演者年龄经过严格验证，且平台运营受日本法律监管。选择这些正版渠道观看，既保护自身权益，也支持行业健康发展。',
  },
  {
    question: '海外用户如何合法观看日本成人视频？',
    answer: '海外用户可以通过FANZA、R18.com等面向国际服务的正版平台合法观看。需要注意的是，不同国家/地区对成人内容的法律规定不同，请提前了解所在地法律。建议使用VPN保护隐私，但VPN的使用本身也需遵守当地法规。',
  },
  {
    question: '正版平台的费用大概是多少？',
    answer: '日本正版成人视频的单体购买价格通常在1500-3500日元（约合人民币70-160元）。FANZA月费会员约990日元/月（约45元），可享受作品购买折扣。部分平台提供租赁选项，价格约为永久购买的30-50%，适合偶尔观看的用户。',
  },
  {
    question: '如何保护观看成人内容时的隐私和安全？',
    answer: '建议采取多层安全措施：使用无日志政策的VPN服务加密网络连接；创建专用浏览器配置文件隔离浏览数据；使用虚拟信用卡或加密货币进行支付；安装广告拦截器和防病毒软件；避免在公共Wi-Fi环境下访问相关网站。',
  },
  {
    question: '中文字幕的正版作品多吗？',
    answer: '目前FANZA平台约有5000部作品提供中文字幕，且数量持续增长。新作通常需要1-3个月的字幕制作周期。搜索时使用「中文（簡体字）」筛选器可快速定位支持中文的作品。部分平台也在尝试利用AI技术加速字幕生成。',
  },
  {
    question: '如何控制成人内容消费支出？',
    answer: '建议将成人内容消费纳入整体娱乐预算（通常不超月收入2-3%）。利用平台促销活动和积分返还节省开支，设置「冷却期」减少冲动消费。对于高频用户，月费会员通常比单次购买更经济。使用记账App跟踪支出，定期回顾是否合理。',
  },
];

export default function Home() {
  const featuredArticles = articles.slice(0, 6);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '成人视频指南',
    url: 'https://example.com',
    description: '日本成人视频完整指南，涵盖正版平台推荐、法律法规解读、安全观看须知、行业深度分析等专业内容，帮助成年用户安全合法获取成人娱乐资源。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '成人视频指南',
    url: 'https://example.com',
    description: '致力于为成年用户提供日本成人视频相关的合法合规指南与正版资源推荐',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>

      <div className="min-h-screen">
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20gradient%20background%20with%20soft%20flowing%20lines%20and%20gentle%20texture%2C%20minimalist%20elegant%20design%2C%20warm%20crimson%20and%20golden%20amber%20hues%2C%20Japanese%20aesthetic%20inspired%2C%20clean%20and%20sophisticated&width=1600&height=800&seq=hero-bg-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-6 leading-tight">
              日本成人视频
              <br />
              <span className="text-accent-500">完整指南</span>
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              全面了解日本成人视频的分类、法律合规、正版平台推荐及观看注意事项。
              帮助成年用户安全、合法地获取相关内容，保护个人隐私与设备安全，理性消费成人娱乐资源。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/pingtai-tuijian"
                className="px-8 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览平台推荐
              </Link>
              <Link
                to="/category/anquan-zhinan"
                className="px-8 py-3 bg-background-50/15 text-white border border-white/30 rounded-md text-sm font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                安全指南
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                内容分类导航
              </h2>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                按主题浏览我们精心整理的内容分类，快速找到您关注的信息
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-background-300/60 transition-all duration-300 flex flex-col items-center text-center cursor-pointer"
                >
                  <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-3 transition-transform group-hover:scale-110 ${
                    cat.color === 'primary' ? 'bg-primary-100/80 text-primary-600' :
                    cat.color === 'accent' ? 'bg-accent-100/80 text-accent-900' :
                    'bg-secondary-100/80 text-secondary-900'
                  }`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold font-heading text-foreground-950 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                  精选文章
                </h2>
                <p className="text-sm text-foreground-600">
                  最受关注的深度内容和实用指南
                </p>
              </div>
              <Link
                to="/category/hangye-zixun"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {featuredArticles.map((article) => {
                const category = categories.find((c) => c.id === article.categoryId);
                return (
                  <div key={article.id}>
                    <ArticleCardWrapper
                      title={article.title}
                      slug={article.slug}
                      excerpt={article.excerpt}
                      categoryName={category?.name || ''}
                      categorySlug={category?.slug || ''}
                      author={article.author}
                      publishDate={article.publishDate}
                      readTime={article.readTime}
                      tags={article.tags}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">
                关于日本成人视频的常见疑问解答
              </p>
            </div>
            <div className="space-y-3">
              {faqData.map((faq, index) => (
                <details key={index} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/50 transition-colors list-none">
                    <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</h3>
                    <i className="ri-add-line text-foreground-500 group-open:hidden transition-transform"></i>
                    <i className="ri-subtract-line text-foreground-500 hidden group-open:block transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-14 md:py-18 bg-primary-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
              开始安全合规的观看之旅
            </h2>
            <p className="text-sm text-background-50/80 mb-8 max-w-lg mx-auto leading-relaxed">
              访问我们的平台推荐页面，了解最全面的正版日本成人视频平台对比信息，
              选择最适合您的合法观看渠道。
            </p>
            <Link
              to="/category/pingtai-tuijian"
              className="inline-flex px-8 py-3 bg-background-50 text-primary-600 rounded-md text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              探索平台推荐
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}

function ArticleCardWrapper({
  title, slug, excerpt, categoryName, categorySlug, author, publishDate, readTime, tags,
}: {
  title: string; slug: string; excerpt: string; categoryName: string;
  categorySlug: string; author: string; publishDate: string; readTime: string; tags: string[];
}) {
  const imageUrl = articleImageUrls[slug] || 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20Japanese%20media%20guide%20on%20a%20clean%20desk%20with%20soft%20warm%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=default&orientation=landscape';

  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group hover:border-background-300/60 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="aspect-[16/10] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap hover:bg-secondary-200 transition-colors cursor-pointer"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-500">{publishDate}</span>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`}>
          <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{author}</span>
          <div className="flex items-center gap-1.5 flex-wrap justify-end">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="text-xs px-2 py-0.5 rounded bg-background-200/70 text-foreground-600 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}